module.exports = __webpack_public_path__ + "img/cnu_gallery4.91e879ce.jpg";